import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAttentionTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke="#17181A">
      <path d="M11.569 5.219a.5.5 0 0 1 .862 0l8.252 14.027a.5.5 0 0 1-.431.754H3.748a.5.5 0 0 1-.43-.753l8.251-14.028ZM12 9.5V15" />
      <circle cx={12} cy={17} r={1} />
    </g>
  </svg>
);
const Memo = memo(SvgAttentionTriangle);
export default Memo;
